var _style, _circle, _path, _path2, _circle2, _g, _path3, _path4, _polyline, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilliard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 511.3,
    cy: 636,
    r: 257.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.7,394.9c0.1-2.3,0.1-4.6,0.1-6.9c0-142.1-115.2-257.4-257.4-257.4S87,245.9,87,388 c0,110.4,69.4,204.5,167,241.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,192.7c45-38.7,103.6-62.1,167.6-62.1C821.8,130.6,937,245.9,937,388c0,110.9-70.1,205.4-168.4,241.6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 511.3,
    cy: 636,
    r: 136.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 511.3,
    cy: 600.8,
    rx: 41.7,
    ry: 35.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 511.3,
    cy: 671.1,
    rx: 41.7,
    ry: 35.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.8,384.8c9.4-18.5,14.7-39.5,14.7-61.7c0-75.4-61.1-136.5-136.5-136.5s-136.5,61.1-136.5,136.5 c0,72.4,56.4,131.7,127.7,136.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M751.5,543.2c2.7,0.2,5.5,0.2,8.2,0.2c75.4,0,136.5-61.1,136.5-136.5s-61.1-136.6-136.5-136.6 c-74.5,0-135,59.6-136.5,133.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "326,277.5 350.4,273.7 313.7,376.3 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M713.9,411.1c-13.5-15.5-8.1-34.6,7.3-48.1s35.2-16.4,48.7-0.9c13.5,15.5,8.1,34.6-7.3,48.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M762.6,410.2c-15.5,13.5-20.3,33.4-6.7,48.8l7.6,8.7c3.7,4.2,10.1,4.6,14.3,1l40.9-35.8 c4.1-3.6,4.5-9.8,0.9-13.9l-6.5-7.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilliard);
export default __webpack_public_path__ + "static/media/Billiard.57693e65.svg";
export { ForwardRef as ReactComponent };